import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { ExportButton, getAuthorities, redirectToPages } from "../../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../../_metronic/_partials/controls";
import { TeachersFilter } from "./receipent-teachers-filter/TeachersFilter";
import { TeachersTable } from "./receipent-teachers-table/TeachersTable";

export function TeachersCard() {
  // Getting curret state of Teachers from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.privateNotices }),
    shallowEqual
  );  
  const { isSuccess, type, authorities } = currentState;

  // Authority Parameters
  const { isExportationAuthorized } = getAuthorities(authorities);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      <CardHeader title="Gönderilen Öğretmen Listesi">
        {
          isExportationAuthorized &&
          <CardHeaderToolbar>            
            <ExportButton
              // exportToExcel={exportPrivateNoticesToExcel}
              // exportToPDF={exportPrivateNoticesToPDF}
              // print={printPrivateNotices}
              // copy={copyPrivateNotices}
            />            
          </CardHeaderToolbar>
        }
      </CardHeader>
      <CardBody>
        <TeachersFilter />
        <TeachersTable />
      </CardBody>
    </Card>
  );
}